import { useQuery } from 'react-query';
import { model as clientProgressModel, WidgetChartResponse } from '../progress';

export const widgetPeriodChartQueryKey = (clientId, widgetId, periodId) => ['client', clientId, 'widget', widgetId, 'period', periodId];

export const useWidgetPeriodChart = (clientId, widgetId, periodId) =>
  useQuery<WidgetChartResponse>(widgetPeriodChartQueryKey(clientId, widgetId, periodId), () =>
    clientProgressModel(clientId).getWidgetPeriodChart(widgetId, periodId),
  );
